import { csCZ as coreCsCZ, enUS as coreEnUS, skSK as coreSkSK } from '@mui/material/locale';
import { csCZ as gridCsCZ, enUS as gridEnUS, skSK as gridSkSK } from '@mui/x-data-grid/locales';
import {
  csCZ as pickersCsCZ,
  enUS as pickersEnUS,
  skSK as pickersSkSK,
} from '@mui/x-date-pickers/locales';
import 'dayjs/locale/cs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/sk';
import type { Language } from './language';

/**
 * MUI's own translations, merged into the theme so every built-in string — the data grid's column
 * menu, its pagination, the table footers — follows the switcher without a single prop being passed
 * per component. `enUS` is a no-op merge, kept so all three languages go through the same path.
 */
export const muiCoreLocales = {
  en: coreEnUS,
  cs: coreCsCZ,
  sk: coreSkSK,
} satisfies Record<Language, object>;

export const muiGridLocales = {
  en: gridEnUS,
  cs: gridCsCZ,
  sk: gridSkSK,
} satisfies Record<Language, object>;

export const muiPickersLocales = {
  en: pickersEnUS,
  cs: pickersCsCZ,
  sk: pickersSkSK,
} satisfies Record<Language, object>;

/**
 * dayjs locale tags for the date pickers' input and calendar formats. Imported above as side
 * effects — dayjs only knows the locales that have been loaded. `en-gb` to match `intlLocales`,
 * which pins day-first dates for English too.
 */
export const dayjsLocales: Record<Language, string> = {
  en: 'en-gb',
  cs: 'cs',
  sk: 'sk',
};
